// extracted by mini-css-extract-plugin
export default {"signup-form":"signup_signup-form__BwT3V"};